import { Row, Col, Form, FormCheck } from "react-bootstrap";

const PlaylistsSlotRuntime = (
  programDetails,
  setProgramDetails,
  setFormEdited,
  isLocked
) => {
  function minutesToHm(time) {
    let minutes = time;
    let hours = Math.floor(minutes / 60);
    let remainingMinutes = minutes % 60;

    let timeString = `${hours.toString().padStart(2, "0")}:${remainingMinutes
      .toString()
      .padStart(2, "0")}`;

    return timeString;
  }
  const programEndTime = minutesToHm(
    programDetails.startTime.startTimeHours * 60 +
      programDetails.startTime.startTimeMinutes +
      programDetails.slotRuntime.slotRuntimeHours * 60 +
      programDetails.slotRuntime.slotRuntimeMinutes
  );

  return (
    <Form.Group controlId="slotRuntimeInput">
      <Row className="align-items-center pt-2 ">
        <Form.Label
          column
          sm="2"
        >
          Slot:
        </Form.Label>
        <Col>
          <Row>
            <Col>
              <Form.Select
                value={programDetails.slotRuntime.slotRuntimeHours}
                size="sm"
                onChange={(e) => {
                  setProgramDetails({
                    ...programDetails,
                    slotRuntime: {
                      ...programDetails.slotRuntime,
                      slotRuntimeHours: parseInt(e.target.value),
                      slotRuntime:
                        parseInt(e.target.value) * 60 +
                        programDetails.slotRuntime.slotRuntimeMinutes,
                      isDirty: true,
                    },
                  });
                  setFormEdited(true);
                }}
                disabled={isLocked}
                className={programDetails.slotRuntime.isDirty && "text-danger"}
              >
                {[...Array(7).keys()].map((hour) => (
                  <option
                    key={hour}
                    value={hour}
                  >
                    {hour} hrs
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col>
              <Form.Select
                value={programDetails.slotRuntime.slotRuntimeMinutes}
                size="sm"
                onChange={(e) => {
                  setProgramDetails({
                    ...programDetails,
                    slotRuntime: {
                      ...programDetails.slotRuntime,
                      slotRuntimeMinutes: parseInt(e.target.value),
                      slotRuntime:
                        programDetails.slotRuntime.slotRuntimeHours * 60 +
                        parseInt(e.target.value),
                      isDirty: true,
                    },
                  });
                  setFormEdited(true);
                }}
                disabled={isLocked}
                className={programDetails.slotRuntime.isDirty && "text-danger"}
              >
                {[...Array(60 / 5).keys()].map((index) => (
                  <option
                    key={index}
                    value={index * 5}
                  >
                    {index * 5} mins
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
        </Col>
        <Col sm="1">
          <FormCheck
            type="checkbox"
            isValid
            checked={programDetails.slotRuntime.isDirty}
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                slotRuntime: {
                  ...programDetails.slotRuntime,
                  isDirty: e.target.checked,
                },
              });
              setFormEdited(true);
            }}
            disabled={isLocked}
          />
        </Col>
      </Row>
      <Row>
        <Col
          xs={11}
          className="text-end"
        >
          End of Program: {programEndTime}
        </Col>
      </Row>
    </Form.Group>
  );
};
export default PlaylistsSlotRuntime;
